import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { abortActivePolls } from '../api/utils/response/pollAbortRegistry';
import { getPollScopeKey } from '../utils/getPollScopeKey';

// Aborts every in-flight long-running poll loop when the dataset/subset data
// container changes, so the app stops polling for data the user left behind.
// Keyed by the data scope (not the raw pathname): going deeper within the same
// container — opening a form, filter, export or row detail — keeps the scope
// unchanged, so the cleanup does NOT fire and the poll keeps running (returning
// from the form then still resolves the original load instead of hanging).
const useAbortPollsOnNavigation = (): void => {
  const { pathname } = useLocation();
  const scope = getPollScopeKey(pathname);

  // The cleanup fires only when `scope` actually changes (or on unmount) —
  // that change IS the "left the dataset/subset" signal. Running it in cleanup
  // (rather than the effect body) keeps it ordered before the new container's
  // fetch effect, so a freshly started poll for the destination is not aborted.
  useEffect(() => {
    return () => {
      abortActivePolls();
    };
  }, [scope]);
};

export default useAbortPollsOnNavigation;
